import { useTranslation } from 'react-i18next';

import { SVGIconType } from '../../../constants/svgIcon';
import { SvgIcon } from '../../Molecules';
import { BasicPopupContainer } from '../Containers/BasicPopupContainer';

import styles from './HeadphonesSuggestedInfoPopup.module.css';

type HeadphonesSuggestedInfoPopupProps = {
  onPrimary: () => void;
};

export const HeadphonesSuggestedInfoPopup = (
  props: HeadphonesSuggestedInfoPopupProps,
) => {
  const { onPrimary } = props;
  const { t } = useTranslation();

  return (
    <BasicPopupContainer onPrimaryButtonClick={onPrimary}>
      <div className={styles.popupContent}>
        <div className={styles.icon}>
          <SvgIcon
            name={SVGIconType.Headphone}
            width={80}
            height={80}
            color={'#333333'}
          />
        </div>
        <div className={styles.description}>
          {t(
            'Put on headphones and read aloud while playing to enhance effectiveness by 3x.',
          )}
        </div>
      </div>
    </BasicPopupContainer>
  );
};
